import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import zhTranslation from '../../locales/zh.json';

// This deployment serves Simplified Chinese, including returning browsers.
document.documentElement.lang = 'zh-CN';
try {
  localStorage.setItem('i18nextLng', 'zh');
} catch {
  // The interface also works when browser storage is unavailable.
}

i18n.use(initReactI18next).init({
  resources: { zh: { translation: zhTranslation } },
  lng: 'zh',
  fallbackLng: 'zh',
  supportedLngs: ['zh'],
  debug: false,
  defaultNS: 'translation',
  interpolation: { escapeValue: false },
});

export default i18n;
